<style scoped>
.v-application .text-h5 {
  font-family: "Prompt", sans-serif !important;
}
</style>

<template>
  <v-card>
    <v-navigation-drawer app :mini-variant="showMenu()" permanent>
      <v-row class="fill-height" no-gutters>
        <v-navigation-drawer
          dark
          mini-variant
          width="50px"
          mini-variant-width="50"
          permanent
          app
          color="light-blue darken-2"
        >
          <br />

          <!-- <v-divider></v-divider> -->

          <v-list>
            <v-list-item
              v-for="item in items"
              :key="item.name"
              link
              :to="item.to"
            >
              <v-list-item-action @click="checkMenu(item)">
                <v-tooltip right style="z-index: 500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      style="font-size: 30px !important"
                      >{{ item.icon }}</v-icon
                    >
                  </template>
                  <span>{{ item.descript }}</span>
                </v-tooltip>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider
            class="mb-5"
            style="
              border-width: 1px;
              border-color: white;
              width: 85%;
              margin-right: auto;
              margin-left: auto;
            "
          ></v-divider>
          <v-list-item :to="'/settings/company-profile'">
            <v-list-item-action @click="settings()">
              <v-tooltip right style="z-index: 500">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    style="font-size: 30px !important"
                    >mdi-account-cog</v-icon
                  >
                </template>
                <span>การตั้งค่า</span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-list-item-avatar>
              <v-menu
                offset-x
                :close-on-content-click="true"
                nudge-width="100"
                z-index="9999"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-img
                    src="@/assets/logout.png"
                    v-bind="attrs"
                    v-on="on"
                  ></v-img> 
                  <!-- <v-btn color="indigo" dark v-bind="attrs" v-on="on">Menu as Popover</v-btn> -->
                </template>

                <v-card>
                  <v-list>
                    <v-list-item>
                      <v-list-item-avatar style="background-color:white">
                        <img
                          src="@/assets/newchok-icon.png"
                          v-if="this.$AppName.name == 'นิวโชคอำนวยเชียงใหม่'"
                        />
                        <img
                          src="@/assets/municipalitylogo.png"
                          v-if="this.$AppName.name == 'เทศบาลนครเชียงใหม่'"
                        />
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title>{{
                          this.$AppName.limited_company
                        }}</v-list-item-title>
                        <v-list-item-subtitle
                          >เจ้าของกิจการ version 1.0.5
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                  <v-divider></v-divider>

                  <v-list>
                    <v-list-item>
                      <v-btn
                        elevation="0"
                        color="white"
                        style="width: 100%"
                        @click="logout()"
                      >
                        <v-icon left>mdi-logout</v-icon>ออกจากระบบ
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </v-list-item-avatar>
          </v-list-item>
          <!-- <v-list-item>
            <v-list-item-action>
              <v-tooltip right style="z-index: 500">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    style="font-size: 30px !important"
                    >mdi-alpha-v</v-icon
                  >
                </template>
                <span>version 1.0.1 </span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item> -->
        </v-navigation-drawer>

        <v-list
          nav
          dense
          style="background-color: ##fafafa; width: 100%"
          class="ml-15"
        >
          <br />
          <v-subheader class="mx-4 text-h5">{{ sub_title }}</v-subheader>
          <v-divider class="my-3"></v-divider>
          <v-list-item-group v-model="item_group" color="primary">
            <v-list-item
              v-for="item in sub_item"
              :key="item.name"
              link
              class="my-1"
              :to="item.to"
            >
              <v-list-item-icon class="mr-3 mb-1">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-row>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
export default {
  name: "SideMenu",
  data: () => ({
    drawer: true,
    item_group: 0,
    sub_title: "",
    items: [
      {
        name: "Dashboard",
        icon: "mdi-finance",
        descript: "รายงาน",
        to: "/dashboard/bill-report",
      },
      {
        name: "Qeue",
        icon: "mdi-truck",
        descript: "ข้อมูลวิ่งรถ",
        to: "/qeue/car-qeue",
      },
      {
        name: "newCustomer",
        icon: "mdi-account-multiple",
        descript: "ลูกค้า",
        to: "/newCustomer/all-newCustomer",
      },

      {
        name: "Seller",
        icon: "mdi-currency-usd",
        descript: "เอกสารขาย",
        to: "/seller-order/quotation",
      },
      {
        name: "Contract",
        icon: "mdi-file-clock-outline",
        descript: "สัญญา",
        to: "/contract/all-contract",
      },

      {
        name: "WasteDocument",
        icon: "mdi-file-document-edit",
        descript: "เอกสาร ตช.",
        to: "/wastedocument/waste-document",
      },
      {
        name: "Manage",
        icon: "mdi-folder-open",
        descript: "จัดการข้อมูลทั่วไป",
        to: "/manage/all-personnel",
      },
      // {
      //   name: "Report",
      //   icon: "mdi-monitor-dashboard",
      //   descript: "รายงาน",
      //   to: "/report",
      // },
    ],
    sub_item: [],
  }),
  watch: {
    $route: {
      handler(to, from, next) {
        this.checkMenu(to.matched[0]);
      },
      // immediate: true
    },
  },
  mounted() {},
  methods: {
    settings() {
      this.checkMenu({ name: "Setting" });
    },
    logout() {
      this.$swal({
        title: "ออกจากระบบ",
        text: `กรุณากดปุ่ม "ยีนยัน" เพื่อออกจากระบบ`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          localStorage.clear();
          this.$router.push({ path: "/" });
        }
      });
    },
    showMenu() {
      return this.$store.getters["Drawer/GET_MINI"];
    },
    href() {
      return this.item.href || (!this.item.to ? "#" : undefined);
    },
    checkMenu(item) {
      this.$store.commit("Drawer/SET_SUBMENU_NAME", item.name);
      let subname = this.$store.getters["Drawer/GET_SUBMENU_NAME"];

      if (subname == "") {
        // this.$store.commit("Drawer/SET_MINI_MENU", true);
      } else if (subname == "Seller") {
        this.sub_title = "เอกสารขาย";
        this.sub_item = [
          {
            name: "ใบเสนอราคา",
            icon: "mdi-file-document-outline",
            to: "/seller-order/quotation",
          },
          {
            name: "ใบวางบิล / แจ้งหนี้",
            icon: "mdi-file-document-outline",
            to: "/seller-order/bill",
          },
          {
            name: "ใบกำกับภาษี / ใบเสร็จรับเงิน",
            icon: "mdi-file-document-outline",
            to: "/seller-order/invoices",
          },
        ];
        this.$store.commit("Drawer/SET_MINI_MENU", false);
      } else if (subname == "Buyer") {
        this.sub_title = "เอกสารซื้อ";
        this.sub_item = [
          { name: "ใบสั่งซื้อ", icon: "mdi-file-document-outline" },
          { name: "ใบรับสินค้า / แจ้งหนี้", icon: "mdi-file-document-outline" },
        ];
        this.$store.commit("Drawer/SET_MINI_MENU", false);
      } else if (subname == "Contract") {
        this.sub_title = "สัญญา";
        this.sub_item = [
          {
            name: "สัญญาทั้งหมด",
            icon: "mdi-file-document-outline",
            to: "/contract/all-contract",
          },
          {
            name: "ลูกค้าหมดสัญญา",
            icon: "mdi-file-alert-outline",
            to: "/contract/expire-contract",
          },
        ];
        this.$store.commit("Drawer/SET_MINI_MENU", false);
      } else if (item.name == "Manage") {
        this.sub_title = "ข้อมูลทั่วไป";
        this.sub_item = [
          {
            name: "ข้อมูลพนักงานทั้งหมด",
            icon: "mdi-account-multiple",
            to: "/manage/all-personnel",
          },
          {
            name: "ข้อมูลรถทั้งหมด",
            icon: "mdi-truck",
            to: "/manage/all-car",
          },
          {
            name: "ข้อมูลสินค้าทั้งหมด",
            icon: "mdi-package-variant-closed",
            to: "/manage/all-supply",
          },
        ];
        this.$store.commit("Drawer/SET_MINI_MENU", false);
      } else if (item.name == "WasteDocument") {
        this.sub_title = "เอกสาร ตช.";
        this.sub_item = [
          {
            name: "เอกสาร ตช.ทั้งหมด",
            icon: "mdi-file-document-outline",
            to: "/wastedocument/waste-document",
          },
          {
            name: "รายงาน ตช.",
            icon: "mdi-file-document-outline",
            to: "/wastedocument/report-wastdocument",
          },
        ];
        this.$store.commit("Drawer/SET_MINI_MENU", false);
      } else if (item.name == "newCustomer") {
        this.sub_title = "ข้อมูลลูกค้า";
        this.sub_item = [
          {
            name: "ทะเบียนลูกค้า",
            icon: "mdi-file-account-outline",
            to: "/newCustomer/all-newCustomer",
          },
          {
            name: "ลูกค้าลงทะเบียนใหม่",
            icon: "mdi-file-find-outline",
            to: "/newCustomer/confirm-newCustomer",
          },
          // {
          //   name: "ลูกค้าที่ได้รับใบเสนอราคา",
          //   icon: "mdi-file-table-outline",
          //   to: "/newCustomer/quotation-customer",
          // },
          // {
          //   name: "ลูกค้าโอนเงินแล้ว",
          //   icon: "mdi-account-cash-outline",
          //   to: "/newCustomer/payment-customer",
          // },
          // {
          //   name: "ลูกค้าไม่ทำสัญญา",
          //   icon: "mdi-file-cancel-outline",
          //   to: "/newCustomer/cancel-customer",
          // },
          {
            name: "พิมพ์ QR-code",
            icon: "mdi-qrcode-edit",
            to: "/newCustomer/print-qrcode",
          },
        ];
        this.$store.commit("Drawer/SET_MINI_MENU", false);
      } else if (item.name == "Qeue") {
        this.sub_title = "ข้อมูลวิ่งรถ";
        this.sub_item = [
          {
            name: "ข้อมูลคิวรถ",
            icon: "mdi-truck",
            to: "/qeue/car-qeue",
          },
          // {
          //   name: "จัดการโซนรถ",
          //   icon: "mdi-map-check-outline",
          //   to: "/qeue/manage-zone",
          // },
        ];
        this.$store.commit("Drawer/SET_MINI_MENU", false);
      } else if (item.name == "Setting") {
        this.sub_title = "การตั้งค่า";
        this.sub_item = [
          {
            name: "ข้อมูลธุรกิจ",
            icon: "mdi-office-building",
            to: "/settings/company-profile",
          },
          {
            name: "ข้อมูลโรงกำจัด",
            icon: "mdi-office-building",
            to: "/settings/company-data-destroy",
          },
          //  {
          //   name: "เพิ่มข้อมูลโรงกำจัด",
          //   icon: "mdi-office-building",
          //   to: "/settings/company-insert-destroy",
          // },
        ];
        this.$store.commit("Drawer/SET_MINI_MENU", false);
      } else if (item.name == "Dashboard") {
        this.sub_title = "รายงาน";
        this.sub_item = [
          // {
          //   name: "รายงานภาพรวม",
          //   icon: "mdi-chart-arc",
          //   to: "/dashboard/all-report",
          // },
          {
            name: "ใบวางบิล/แจ้งหนี้",
            icon: "mdi-chart-line",
            to: "/dashboard/bill-report",
          },
          {
            name: "ใบกำกับภาษี/ใบเสร็จรับเงิน",
            icon: "mdi-chart-line",
            to: "/dashboard/invoice-report",
          },
          {
            name: "รายงาน ตช.",
            icon: "mdi-chart-scatter-plot-hexbin",
            to: "/dashboard/waste-report",
          },
        ];
        this.$store.commit("Drawer/SET_MINI_MENU", false);
      } else {
        this.$store.commit("Drawer/SET_MINI_MENU", true);
      }
      // console.log(this.$store.getters["Drawer/GET_MINI"])
    },
  },
};
</script>
